import {Action} from "./base/Action";

export default function ShowMessage(props)
{
    function buttonPress()
    {
        alert("Showing dialog")
    }
    return (<Action onClick={buttonPress} type={props.type} props={props.props}>Show Dialog</Action>);
}